/**
 * Formato do CPF e do telefone do usuario na tela.
 *
 * O servidor guarda so os digitos e confere o CPF pelos digitos verificadores. A
 * mascara e da tela, como no OnPoint, que mostra o telefone em (99) 9999-9999.
 */

/** Tira a mascara: pontos, tracos, parenteses e espacos. */
export function soDigitos(valor: string): string {
  return valor.replace(/\D/g, '');
}

/** CPF com a mascara 000.000.000-00, ou o que foi digitado quando incompleto. */
export function formatarCpf(valor: string): string {
  const digitos = soDigitos(valor);
  if (digitos.length !== 11) return valor;
  return `${digitos.slice(0, 3)}.${digitos.slice(3, 6)}.${digitos.slice(6, 9)}-${digitos.slice(9)}`;
}

/** Telefone com DDD: (99) 9999-9999 ou (99) 99999-9999. */
export function formatarTelefone(valor: string): string {
  const digitos = soDigitos(valor);
  if (digitos.length === 10) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
  }
  if (digitos.length === 11) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
  }
  return valor;
}
